//use Auth0
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom"
import { useSelector } from "react-redux";
import clsx from "clsx";
import MenuCart from "./sub-components/MenuCart";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import { useAuth } from '../../helpers/auth-context'; // Import useAuth0 hook

const IconGroup = ({ iconWhiteClass }) => {

  const navigate = useNavigate(); // Use useNavigate to access navigation function
  const [searchQuery, setSearchQuery] = useState('');
  const { isAuthenticated, logout } = useAuth(); // Use Auth0 authentication state

  const handleLogout = () => {
    const returnTo = process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_DEV_LOGOUT_URL
      : process.env.REACT_APP_PROD_LOGOUT_URL;

    console.log('Logout URL:', returnTo);
    logout({ logoutParams: { returnTo: returnTo } })
    // logout({ returnTo });
    localStorage.clear();
  };


  const handleClick = e => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };


  const handleSearch = (e) => {
    e.preventDefault();
    // Navigate to the ShopGridNoSidebar page with the search query as a URL parameter
    navigate(`/shop-grid-no-sidebar?search=${searchQuery}`);
  };


  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };
  const { compareItems } = useSelector((state) => state.compare);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { cartItems } = useSelector((state) => state.cart);
  const { t } = useTranslation()

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)} >
      <div className="same-style header-search">
        <button className="search-active" onClick={e => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form onSubmit={handleSearch}>
            <input
              type="text"
              placeholder={t("Enter Keyword")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="button-search" type="submit">
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>
      <div className="same-style header-compare">
        <Link to={process.env.PUBLIC_URL + "/my-notes"}>
          <i className="pe-7s-note" />
          <span className="">
          </span>
        </Link>
      </div>
      <div className="same-style account-setting ">
        <button
          className="account-setting-active"
          onClick={e => handleClick(e)}
        >
          <i className="pe-7s-user-female" />
        </button>
        <div className="account-dropdown">
          <ul>
            <li>
              {isAuthenticated? (
                // <a href="#" onClick={handleLogout}>
                <a href="#" onClick={handleLogout}>
                Logout
                </a>
                ):(
                <Link to={process.env.PUBLIC_URL + "/login-register"}>Login</Link>
              )}
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/my-account"}>
                {t("My Account")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="same-style header-compare d-none d-lg-block">
        <Link to={process.env.PUBLIC_URL + "/compare"}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">
            {compareItems && compareItems.length ? compareItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style header-wishlist d-none d-lg-block" >
        <Link to={process.env.PUBLIC_URL + "/wishlist"}>
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <button className="icon-cart" onClick={e => handleClick(e)}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </button>
        {/* menu cart */}
        <MenuCart />
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;

// use supabase

// import PropTypes from "prop-types";
// import {Link} from "react-router-dom";
// import {useNavigate} from "react-router-dom"
// import { useSelector } from "react-redux";
// import clsx from "clsx";
// import MenuCart from "./sub-components/MenuCart";
// import {useTranslation} from "react-i18next";
// import {useEffect, useState} from "react";
// import { useSupabase } from '../../helpers/supa-base.js';
// import {useUrlContext} from "../../helpers/url-context"; // Update the path to match your context file
//
//
// const IconGroup = ({ iconWhiteClass }) => {
//
//   const navigate = useNavigate(); // Use useNavigate to access navigation function
//   const [searchQuery, setSearchQuery] = useState('');
//   const {supabase} = useSupabase();
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   // const {previousLocation} = useUrlContext();
//   // const previousStoredLocation = localStorage.getItem('previousLocation');
//   // console.log("user icon stored Location before login", previousStoredLocation, "user click Location", previousLocation)
//
//   useEffect(() => {
//     if (supabase?.auth) {
//       supabase.auth.onAuthStateChange((event, session) => {
//         if (session?.user) {
//           setIsAuthenticated(true);
//         } else {
//           setIsAuthenticated(false);
//         }
//         // console.log("user logout onAuthStateChange event: ", event, " session: ", session, "stored previousLocation", previousLocation)
//       });
//       return () => {
//       };
//     }
//   }, [isAuthenticated])
//
//
//
//   const handleLogout = async () => {
//     // Perform the sign-out action
//     await supabase.auth.signOut();
//     localStorage.clear()
//     navigate(process.env.PUBLIC_URL + "/");
//     console.log('user has logout')
//   };
//
//   const handleClick = e => {
//     e.currentTarget.nextSibling.classList.toggle("active");
//   };
//
//
//   const handleSearch = (e) => {
//     e.preventDefault();
//     // Navigate to the ShopGridNoSidebar page with the search query as a URL parameter
//     navigate(`/shop-grid-no-sidebar?search=${searchQuery}`);
//   };
//
//
//   const triggerMobileMenu = () => {
//     const offcanvasMobileMenu = document.querySelector(
//       "#offcanvas-mobile-menu"
//     );
//     offcanvasMobileMenu.classList.add("active");
//   };
//   const { compareItems } = useSelector((state) => state.compare);
//   const { wishlistItems } = useSelector((state) => state.wishlist);
//   const { cartItems } = useSelector((state) => state.cart);
//   const { t } = useTranslation()
//
//   return (
//     <div className={clsx("header-right-wrap", iconWhiteClass)} >
//       <div className="same-style header-search">
//         <button className="search-active" onClick={e => handleClick(e)}>
//           <i className="pe-7s-search" />
//         </button>
//         <div className="search-content">
//           <form onSubmit={handleSearch}>
//             <input
//               type="text"
//               placeholder={t("Enter Keyword")}
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//             <button className="button-search" type="submit">
//               <i className="pe-7s-search" />
//             </button>
//           </form>
//         </div>
//       </div>
//       <div className="same-style header-compare">
//         <Link to={process.env.PUBLIC_URL + "/my-notes"}>
//           <i className="pe-7s-note" />
//           <span className="">
//           </span>
//         </Link>
//       </div>
//       <div className="same-style account-setting ">
//         <button
//           className="account-setting-active"
//           onClick={e => handleClick(e)}
//         >
//           <i className="pe-7s-user-female" />
//         </button>
//         <div className="account-dropdown">
//           <ul>
//             <li>
//               {isAuthenticated? (
//                 <a href="#" onClick={handleLogout}>
//                   Logout
//                 </a>
//               ):(
//                 <Link to={process.env.PUBLIC_URL + "/login-register"}>Login</Link>
//               )}
//             </li>
//             <li>
//               <Link to={process.env.PUBLIC_URL + "/my-account"}>
//                 {t("My Account")}
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </div>
//       <div className="same-style header-compare d-none d-lg-block">
//         <Link to={process.env.PUBLIC_URL + "/compare"}>
//           <i className="pe-7s-shuffle" />
//           <span className="count-style">
//             {compareItems && compareItems.length ? compareItems.length : 0}
//           </span>
//         </Link>
//       </div>
//       <div className="same-style header-wishlist d-none d-lg-block" >
//         <Link to={process.env.PUBLIC_URL + "/wishlist"}>
//           <i className="pe-7s-like" />
//           <span className="count-style">
//             {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
//           </span>
//         </Link>
//       </div>
//       <div className="same-style cart-wrap d-none d-lg-block">
//         <button className="icon-cart" onClick={e => handleClick(e)}>
//           <i className="pe-7s-shopbag" />
//           <span className="count-style">
//             {cartItems && cartItems.length ? cartItems.length : 0}
//           </span>
//         </button>
//         {/* menu cart */}
//         <MenuCart />
//       </div>
//       <div className="same-style cart-wrap d-block d-lg-none">
//         <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
//           <i className="pe-7s-shopbag" />
//           <span className="count-style">
//             {cartItems && cartItems.length ? cartItems.length : 0}
//           </span>
//         </Link>
//       </div>
//       <div className="same-style mobile-off-canvas d-block d-lg-none">
//         <button
//           className="mobile-aside-button"
//           onClick={() => triggerMobileMenu()}
//         >
//           <i className="pe-7s-menu" />
//         </button>
//       </div>
//     </div>
//   );
// };
//
// IconGroup.propTypes = {
//   iconWhiteClass: PropTypes.string,
// };
//
//
//
// export default IconGroup;
